import React from 'react';
import { Flex, Heading, Button, Box, Text } from '@spothero/ui';
const BadDataPage = () => {
    const errorText = `Hmm, we couldn't find that`;
    const subErrorText = (<Text>
            You may have followed an invalid link or pasted an incomplete URL.
        </Text>);
    const buttonValues = {
        text: 'Find a spot nearby',
        props: {
            as: 'a',
            href: '/parking-near-me',
            variant: 'primary',
        },
    };
    return (<Flex flexDirection="column" alignItems="center" justifyContent="center" height="calc(100vh - 14rem)">
            <Heading width="70%" textAlign="center" whiteSpace="pre-line" fontSize="xl" fontWeight="normal" as="h1" lineHeight={1.25}>
                {errorText}
            </Heading>
            {subErrorText ? (<Box marginTop={4} textAlign="center">
                    {subErrorText}
                </Box>) : null}

            <Button marginTop={8} {...buttonValues.props}>
                {buttonValues.text}
            </Button>
        </Flex>);
};
export default BadDataPage;
